import { render, staticRenderFns } from "./system.vue?vue&type=template&id=624a2f4a&scoped=true&"
import script from "./system.js?vue&type=script&lang=js&"
export * from "./system.js?vue&type=script&lang=js&"
import style0 from "./system.scss?vue&type=style&index=0&id=624a2f4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "624a2f4a",
  null
  
)

export default component.exports